import { setIdReduxAction } from '../../../../redux/actions/set-id'
import { PROFILES_ACTION, PROFILES_PATH } from '../../constants'

export function updateCurrentProfileAction (instance) {
  return setIdReduxAction({
    type: instance
      ? PROFILES_ACTION.UPDATE_CURRENT
      : PROFILES_ACTION.DELETE_CURRENT,
    payload: {
      path: PROFILES_PATH.CURRENT,
      instance
    }
  })
}

export default updateCurrentProfileAction
